module.exports = __webpack_public_path__ + "img/milica.d9dd9931.jpg";